import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import './modal.css'

const portalRoot = typeof document !== 'undefined' ? document.body : null

const Modal = ({ isOpen, onClose, title, children, size = 'md' }) => {

  useEffect(() => {
    if (!isOpen) return
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose?.()
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    document.body.style.overflow = 'hidden'

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = ''
    }
  }, [isOpen, onClose])

  if (!isOpen || !portalRoot) {
    return null
  }

  return ReactDOM.createPortal(
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className={`modal-window modal-window--${size}`}>
        <div className="title_and_close">
          {
            title ?
              <h2 className="modal-title">{title}</h2>
              : null
          }
          <button type="button" className="modal-close" onClick={onClose} aria-label="Закрыть">
            ×
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>,
    portalRoot
  )
}

export default Modal
